module.exports = __webpack_public_path__ + "static/media/embassy-icon.e52e613f.svg";